import { Capacitor } from '@capacitor/core';

export const getBaseUrl = (): string => {
  const url = import.meta.env.VITE_BACKEND_API_URL;
  if (!url) {
    throw new Error('VITE_BACKEND_API_URL is not set');
  }
  return url.replace(/\/$/, '');
};

export type Platform = 'web' | 'android' | 'ios';

export const getPlatform = (): Platform => {
  // Use Capacitor's runtime detection so that native builds using serverUrl
  // (which load the web build's JS) still report the correct platform.
  const capacitorPlatform = Capacitor.getPlatform();
  if (capacitorPlatform === 'ios' || capacitorPlatform === 'android') {
    return capacitorPlatform;
  }
  return 'web';
};
